import {ChangeDetectorRef, Component, forwardRef, OnInit} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Manufacturer} from "../../../shared/view-model/crm/manufacturer";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {appInjector} from "../../../index";
import {FetchManufacturersResponse, ManufacturerService} from "../../services/manufacturer.service";
import {SessionActions} from "../../../shared/actions";
import {ApolloQueryObservable} from "apollo-angular";
import {Subject} from "rxjs/Subject";

@Component({
    selector: 'vb-manufacturer-input-field',
    templateUrl: './manufacturer-input-field.component.html',
    styleUrls: ['./manufacturer-input-field.component.css'],
    providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => ManufacturerInputFieldComponent)}]
})
export class ManufacturerInputFieldComponent extends AbstractVisbosControl<Manufacturer, FormGroup> implements OnInit {

    private manuList$: ApolloQueryObservable<FetchManufacturersResponse>;
    manufacturerList: Manufacturer[] = [];

    searchLoading: boolean = false;

    searchText: string | Manufacturer;
    private searchToken$: Subject<string> = new Subject();

    constructor(fb: FormBuilder, private manufacturerService: ManufacturerService, cd: ChangeDetectorRef, sessionActions: SessionActions) {
        super(fb, cd, sessionActions);
    }

    ngOnInit() {
        super.ngOnInit();

        this.manuList$ = this.manufacturerService.getManufacturerList(null, this.searchToken$);
        this.addComponentData(this.manuList$);
        this.dataSubscriptions.push(this.manuList$.subscribe(res => {
            this.searchLoading = res.loading;
            this.manufacturerList = res.data.fetchManufacturers;
        }));

    }

    buildControlContent(): FormGroup {
        return ManufacturerInputFieldComponent.initControl(this.fb);
    }

    public static initControl(fb: FormBuilder = null): FormGroup {
        fb = fb ? fb : appInjector().get(FormBuilder);
        return fb.group({
            cuid: [],
            name: []
        });
    }

    public setDefaultValues(item?: Manufacturer): { [controlKey: string]: any } | any {
        this.searchText = item;
        return {
            cuid: this.setValue(item, 'cuid'),
            name: this.setValue(item, 'name')
        };
    }


    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.searchText = this.item;
    }

    search(event) {
        this.item = null;
        this.control.reset();
        this.control.get('name').setValue(event.query ? event.query : null);

        this.searchToken$.next(event.query);

    }

    onSelect(selectedItem) {
        this.item = selectedItem;
        this.control.patchValue(selectedItem);
    }

    onClear(event) {
        this.searchText = null;
        this.item = null;
        this.control.reset();
    }

}



// WEBPACK FOOTER //
// ./src/app/crm/manufacturer/manufacturer-input-field/manufacturer-input-field.component.ts